
export type ColumnType = 'DA' | 'QA' | 'QT' | 'QS' | 'QP' | 'SA' | 'CO';

export enum COLUMN_TYPE {
    DEUDA_ANTERIOR = 'DA',
    QUINCENA_ANTERIOR = 'QA',
    QUINCENA_ACTUAL = 'QT',
    QUINCENA_SIGUIENTE = 'QS',
    QUINCENA_POSTERIOR = 'QP',
    SALDO = 'SA',
    CONTADO = 'CO',
}